export const GET_SEARCH_PRESETS = "GET_SEARCH_PRESETS";
export const GET_SEARCH_PRESET_BY_ID = "GET_SEARCH_PRESET_BY_ID";
export const UPDATE_SEARCH_PRESET = "UPDATE_SEARCH_PRESET";
export const DELETE_SEARCH_PRESET = "DELETE_SEARCH_PRESET";
export const CREATE_SEARCH_PRESET = "CREATE_SEARCH_PRESET";
